import PropTypes from "prop-types";
import { PopoverItem } from "@shared/v2/Popover";

const StageOption = ({ stageOption, selectStage }) => (
  <>
    {stageOption.header && (
      <div className="tw-inline-block tw-border-[1px] tw-border-solid last:tw-border-none tw-border-neutral-gray-30 " />
    )}
    <PopoverItem
      disabled={stageOption.header}
      data-cy="leads-stage-option"
      className={stageOption.header ? "!tw-bg-tinted-gray-50 !tw-text-gray-75" : ""}
      onClick={selectStage}
    >
      <div className="tw-flex-1 tw-text-center tw-text-11d tw-font-bold">{stageOption?.label}</div>
    </PopoverItem>
    {stageOption.header ? (
      <div className="tw-inline-block tw-border-[1px] tw-border-solid last:tw-border-none tw-border-neutral-gray-30 " />
    ) : (
      <div className="tw-inline-block tw-border-[1px] tw-border-solid first:tw-border-none last:tw-border-none tw-border-gray-10 tw-mx-[45px]" />
    )}
  </>
);

StageOption.propTypes = {
  stageOption: PropTypes.shape({ label: PropTypes.string, value: PropTypes.string, header: PropTypes.string })
    .isRequired,
  selectStage: PropTypes.func.isRequired,
};

export default StageOption;
